import axios from "axios";
import { EnvironmentVariable } from "./constants";

const { localEnvConfig } = EnvironmentVariable;

const HTTPInstance = axios.create({
  baseURL: localEnvConfig.API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export { HTTPInstance };
